import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import * as FullStory from '@fullstory/browser'
import { Observable } from 'rxjs'

import { VerityEnvironmentService } from '../../../../environments/verity-environment.service'

export type FeedbackType = 'Support' | 'Tuning' | 'Syntax' | 'Request'

export interface FeedbackSupport {
  type: FeedbackType
  UUID: string
  message: string
}

export interface ContactSupport {
  name: string
  email: string
  phone?: string
  website: string
  newsletter: boolean
  message: string
}

export interface TrialUnlockRequest {
  fullStoryUrl: string
  requestedContent: string
  message: string
  contentUrl: string
}

@Injectable({
  providedIn: 'root',
})
export class SupportService {
  private httpClient = inject(HttpClient)
  private verityEnvironmentService = inject(VerityEnvironmentService)

  public sendFeedbackEmail(email: FeedbackSupport): Observable<void> {
    return this.httpClient.post<void>(
      `${this.verityEnvironmentService.apiUrl}/support/hunt-package-feedback`,
      email,
    )
  }

  public sendContactEmail(email: ContactSupport): Observable<void> {
    return this.httpClient.post<void>(
      `${this.verityEnvironmentService.apiUrl}/support/contact`,
      email,
    )
  }

  public sendUnlockEmail(
    unlockRequestDetails: Omit<TrialUnlockRequest, 'fullStoryUrl'>,
  ): Observable<void> {
    return this.httpClient.post<void>(
      `${this.verityEnvironmentService.apiUrl}/support/unlock`,
      {
        ...unlockRequestDetails,
        fullStoryUrl: FullStory.getCurrentSessionURL(true),
      },
    )
  }
}
